import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize, take } from 'rxjs/operators';
import { AppUser } from 'src/app/modules/authentication/models/app-user.model';
import { AuthenticationService } from 'src/app/modules/authentication/services/authentication.service';
import { MessageService } from '../../services/message.service';

@UntilDestroy()
@Component({
  selector: 'app-profile-switch',
  templateUrl: './profile-switch.component.html',
  styleUrls: ['./profile-switch.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProfileSwitchComponent implements OnInit {
  user?: AppUser;
  selectedId?: number;
  loading = false;

  constructor(
    private readonly authService: AuthenticationService,
    private readonly cdr: ChangeDetectorRef,
    private readonly messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.authService
      .getUser$()
      .pipe(untilDestroyed(this))
      .subscribe((user) => {
        this.user = user;
        this.updateSelectedId();
        this.cdr.detectChanges();
      });
  }

  onProfileChange(id: number) {
    this.loading = true;
    this.authService
      .switchProfile$(id)
      .pipe(
        take(1),
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe((val) => {
        const decodedToken = AuthenticationService.decodeToken(val.access_token);
        const profileName = val.profiles.find((p) => p.id === Number(decodedToken?.profile))?.name;
        if (profileName != null) {
          this.messageService.showSuccess($localize`Gewisseld naar profiel "${profileName}:profileName:".`);
        }
        setTimeout(() => {
          window.location.reload();
        }, 500);
      });
  }

  private updateSelectedId() {
    const profileId = this.authService.getToken()?.profile;
    if (profileId != null && profileId !== '') {
      this.selectedId = Number(profileId);
    }
  }
}
